<div style="background-color: white">
  <dx-pie-chart type="doughnut"
                [startAngle]="90"
                [resolveLabelOverlapping]="'shift'"
                [palette]="colorPalette"
                [dataSource]="dataSource">
    <dxi-series argumentField="category">
      <dxo-label [visible]="true"
                 [customizeText]="customizeLabel">
        <dxo-connector [visible]="true"></dxo-connector>
      </dxo-label>
    </dxi-series>
    <dxo-export [enabled]="false"></dxo-export>
    <dxo-legend [visible]="false"></dxo-legend>
    <dxo-tooltip [enabled]="true"
                 format="largeNumber">
    </dxo-tooltip>
  </dx-pie-chart>
</div>

